import React from 'react'
import { Box } from '@mui/material'
import { useIsSmallScreen } from 'packages/core'
import DesktopMenu from './DesktopMenu'
import MobileMenu from './MobileMenu'

const GlobalMenu = ({ hideSideNavigation }) => {
    const isSmallScreen = useIsSmallScreen()
    return isSmallScreen ? (
        <MobileMenu hideMSAppsMenu={hideSideNavigation} />
    ) : (
        !hideSideNavigation && (
            <Box
                component="div"
                sx={{ marginTop: '24px' }}
                data-ai-explain="Side navigation: switch between EmpowerID apps and areas"
            >
                <DesktopMenu />
            </Box>
        )
    )
}

export default GlobalMenu
